'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("XlsMetadataPopinController", function ($scope, $q, $http, $notifications, $translate) {
  function initData() {
    var promise;
    var postfix = '?xls-metadata';
    if ($scope.componentUuid) {
      postfix += "&componentUuid=" + $scope.componentUuid;
    }
    if ($scope.defautConfiguration) {
      postfix += "&defautConfiguration=true";
    }
    if ($scope.post) {
      promise = $http.post($scope.url + postfix);
    } else {
      promise = $http.get($scope.url + postfix);
    }
    promise.then(function (response) {
      $scope.metadata = response.data;
      $scope.columns = $scope.metadata.columns;
    });
  }
  initData();
  var columns = [];
  columns.push({
    id: "title",
    title: $translate("xls.metadata.Colonne"),
    attribute: "title",
    template: "<div ng-if=\"model.sharedTitle.length>0\" class=\"b i\">{{model.sharedTitle}}</div>{{model.title}}"
  });
  columns.push({
    id: "visible",
    title: "Excel (.xlsx)",
    headerTemplate: "    <div>Excel (.xlsx)</div><a class=\"toggle-all-btn tl-link\" ng-click=\"toggleAllXlsx()\" ng-switch=\"areAllSelectedXlsx()\">\n" + "                <span ng-switch-when=\"false\">{{\'xls.metadata.Tous\'|translate}}</span>\n" + "                <span ng-switch-when=\"true\">{{\'xls.metadata.Aucun\'|translate}}</span>\n" + "            </a>\n" + "        ",
    template: "<tl-checkbox ng-if='model.availableInXlsx'  ng-model='model.visibleXlsx'></tl-checkbox>" + "<i ng-if='!model.availableInXlsx' class='fa fa-ban grey' tl-tooltip=\"Ce champs n'est pas disponible dans ce format\"></i>",
    cellClass: 'align-c'
  });
  if (!$scope.hideDocx) columns.push({
    id: "visible",
    title: "Word (.docx)",
    headerTemplate: "    <div>Word (.docx)</div><a class=\"toggle-all-btn tl-link\" ng-click=\"toggleAllDocx()\" ng-switch=\"areAllSelectedDocx()\">\n" + "                <span ng-switch-when=\"false\">{{\'xls.metadata.Tous\'|translate}}</span>\n" + "                <span ng-switch-when=\"true\">{{\'xls.metadata.Aucun\'|translate}}</span>\n" + "            </a>\n" + "        ",
    template: "<tl-checkbox ng-if='model.availableInDocx' ng-model='model.visibleDocx'></tl-checkbox>" + "<i ng-if='!model.availableInDocx' class='fa fa-ban grey' tl-tooltip=\"Ce champs n'est pas disponible dans ce format\"></i>",
    cellClass: 'align-c'
  });
  $scope.tableOptions = {
    source: "columns",
    id: 'xlsMetadatas',
    allowSelection: true,
    selectionAttribute: "selectedModel",
    selectionScope: $scope,
    columns: [].concat(columns)
  };
  $scope.save = function () {
    // saving
    $http.post("/rest/xls-metadata/save", $scope.metadata).then(function (response) {
      var validation = response.data;
      // TODO : override values with result.
      if (validation.valid) {
        $notifications.info($translate("xls.metadata.ColonnesEnregistrees"));
        $scope.$close(validation.result);
      } else {
        $scope.errorMessage = validation.errors[0].message;
      }
    });
  };

  // Sélectionne ou désélectionne tous
  $scope.toggleAllXlsx = function () {
    if ($scope.areAllSelectedXlsx()) {
      unselectAllXlsx();
    } else {
      selectAllXlsx();
    }
  };
  $scope.areAllSelectedXlsx = function () {
    return $scope.columns && _.size(_.filter($scope.columns, function (model) {
      return !model.availableInXlsx || model.visibleXlsx === true;
    })) === $scope.columns.length;
  };
  var selectAllXlsx = function selectAllXlsx() {
    _.each($scope.columns, function (p) {
      if (p.availableInXlsx) {
        p.visibleXlsx = true;
      }
    });
  };
  var unselectAllXlsx = function unselectAllXlsx() {
    _.each($scope.columns, function (p) {
      if (p.availableInXlsx) {
        p.visibleXlsx = false;
      }
    });
  };

  // Sélectionne ou désélectionne tous
  $scope.toggleAllDocx = function () {
    if ($scope.areAllSelectedDocx()) {
      unselectAllDocx();
    } else {
      selectAllDocx();
    }
  };
  $scope.areAllSelectedDocx = function () {
    return $scope.columns && _.size(_.filter($scope.columns, function (model) {
      return !model.availableInDocx || model.visibleDocx === true;
    })) === $scope.columns.length;
  };
  var selectAllDocx = function selectAllDocx() {
    _.each($scope.columns, function (p) {
      if (p.availableInDocx) {
        p.visibleDocx = true;
      }
    });
  };
  var unselectAllDocx = function unselectAllDocx() {
    _.each($scope.columns, function (p) {
      if (p.availableInDocx) {
        p.visibleDocx = false;
      }
    });
  };
  $scope.resetToDefaut = function () {
    // saving
    $http.post("/rest/xls-metadata/reset-to-defaut", $scope.metadata).then(function (response) {
      $notifications.info($translate("xls.metadata.ColonnesReinitialisees"));
      initData();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/xls/metadata/xlsMetadataPopin.js
// module id = 3028
// module chunks = 13